(($, Drupal) => {
    Drupal.behaviors.selectIcon = {
        attach: function attach() {
            const selects = $(".grid-triple__select.js-select select");
            selects.select2({
                minimumResultsForSearch: Infinity,
                dropdownCssClass: "select-habermann"
            });
            $(".select-icon").on("click", function(e) {
                e.preventDefault();
                $($(this).find("input.outer-uncheck")).toggleClass("checked");
            })
            $(".select-icon").once("select-icon").each(function() {
                const titleLabel = $($(this).find(".select-title"));
                const titleLabelText = $(titleLabel.find("span span"));
                const titleLabelImg = $(titleLabel.find("span img"));
                $(titleLabel.find(".select-icon__wrapper .select-icon__item")).on("click", function() {
                    titleLabelText.text($(this).text());
                    const wrapper = $(this).closest(".info-card__documents-select");
                    const downloadWrapper = wrapper.find(".info-card__documents-download");
                    console.log(wrapper, downloadWrapper);
                    const checked = $(this).attr("for");
                    $(downloadWrapper.children()).each((index, element) => {
                        const item = $(element)
                        console.log(item, item.attr('id'), checked)
                        if(item.attr('id') === checked)
                            item.prop('checked', true);
                        else item.prop('checked', false);

                    })

                    const imageSrc = $($(this).find("img")).prop("src");
                    if(imageSrc)
                    {
                        titleLabelImg.css("display", "block");
                        titleLabel.removeClass("no-left-padding");
                        titleLabelImg.prop("src", imageSrc);
                    }
                    else 
                    {
                        titleLabel.addClass("no-left-padding");
                        titleLabelImg.css("display", "none");
                    }
                });
            });
        }
    };

})(jQuery, Drupal);
  